<template>
	<div>
		<form class="form-horizontal">
			<ts-loading-banner :loading="loading">
				<div>
					<div class="row">
						<label class="col-md-5 col-form-label">{{
							$t('retailSale.invoiceNumber')
						}} :
						</label>
						<div class="col-md-7">
							<input type="text" disabled v-model="resource.invoice_no"
								class="form-control-plaintext mb-2" />
						</div>
					</div>
					<div class="row">
						<label class="col-md-5 col-form-label">{{
							$t('retailSale.cardNumber')
						}} :
						</label>
						<div class="col-md-7">
							<input type="text" disabled v-model="resource.card_number"
								class="form-control-plaintext mb-2" />
						</div>
					</div>
					<div class="row">
						<label class="col-md-5 col-form-label">{{
							$t('retailSale.student')
						}} :
						</label>
						<div class="col-md-7">
							<input type="text" disabled v-model="resource.full_name_en"
								class="form-control-plaintext mb-2" />
						</div>
					</div>
					<div class="row">
						<label class="col-md-5 col-form-label">{{
							$t('retailSale.sex')
						}} :
						</label>
						<div class="col-md-7">
							<input type="text" disabled v-model="resource.gender" class="form-control-plaintext mb-2" />
						</div>
					</div>
					<div class="row">
						<label class="col-md-5 col-form-label">{{
							$t('retailSale.date')
						}} :
						</label>
						<div class="col-md-7">
							<input type="text" disabled v-model="resource.stock_out_date"
								class="form-control-plaintext mb-2" />
						</div>
					</div>
				</div>
				<div class="ts-overflow-auto">
					<table id="table-details" class="ts-mt-6">
						<thead>
							<tr>
								<th class="ts-whitespace-no-wrap" style="width:200px">
									{{ $t('retailSale.saleCode') }}
								</th>
								<th class="ts-whitespace-no-wrap" style="width: 190px;">
									{{ $t('retailSale.productName') }}
								</th>
								<th class="ts-whitespace-no-wrap" style="width: 70px;">
									{{ $t('retailSale.uom') }}
								</th>
								<th class="ts-whitespace-no-wrap" style="width: 93px;">
									{{ $t('retailSale.quantity') }}
								</th>
								<th class="ts-whitespace-no-wrap" style="width: 94px;">
									{{ $t('retailSale.salePrice') }}
								</th>
								<th class="ts-whitespace-no-wrap" style="width: 81px;">
									{{ $t('retailSale.discountType') }}(%)
								</th>
								<th class="ts-whitespace-no-wrap" style="width: 90px;">
									{{ $t('retailSale.discount') }}
								</th>
								<th class="ts-whitespace-no-wrap" style="width: 81px;">
									{{ $t('retailSale.vat') }}(%)
								</th>
								<th class="ts-whitespace-no-wrap" style="width: 90px;">
									{{ $t('retailSale.amount') }}
								</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(detail, index) in resource.details" :key="index">
								<td valign="top">
									<input type="text" disabled v-model="detail.sale_code"
										class="form-control-plaintext mb-2" />
								</td>
								<td valign="top">
									<input type="text" disabled v-model="detail.product_name_en"
										class="form-control-plaintext mb-2" />
								</td>
								<td valign="top">
									<input type="text" disabled v-model="detail.uom_name_en"
										class="form-control-plaintext mb-2" />
								</td>
								<td valign="top">
									<input type="text" disabled v-model="detail.quantity"
										class="form-control-plaintext mb-2" />
								</td>
								<td valign="top">
									<input type="text" disabled v-model="detail.sale_price
									" class="form-control-plaintext mb-2" />
								</td>
								<td valign="top">
									<input type="text" disabled v-model="detail.discount_type"
										class="form-control-plaintext mb-2" />
								</td>
								<td valign="top">
									<input type="text" disabled v-model="detail.discount_rate"
										class="form-control-plaintext mb-2" />
								</td>
								<td valign="top">
									<input type="text" disabled v-model="detail.vat_rate"
										class="form-control-plaintext mb-2" />
								</td>
								<td valign="top">
									<input type="text" disabled v-model="detail.grand_total"
										class="form-control-plaintext mb-2" />
								</td>
							</tr>
						</tbody>
					</table>

				</div>
			</ts-loading-banner>
		</form>
	</div>
</template>
<script>
export default {
	name: 'testingFeeView',
	props: ['resource', 'loading'],
	data() {
		return {}
	}
}
</script>

<style lang="css" scoped>
label {
	font-size: 12px !important;
}

#table-details>thead>tr>th {
	padding: 5px 4px;
	background: #f2f3f4;
}

#table-details>tbody>tr>td {
	padding: 5px 4px;
	border: none !important;
	font-size: 12px !important;
}
</style>

